import { createContext } from "react";

const MessageContext3 = createContext([]);

export default MessageContext3;
